(function () {
  function getBreakpointKey(w, tabletBp) {
    if (w <= 767) return 'mobile';
    if (w <= (tabletBp || 1024)) return 'tablet';
    return 'desktop';
  }

  function measureTrack($root, $track) {
    var isSlick = $track.hasClass('slick-initialized');
    var trackEl = $track[0];
    var $slides, available, gap;

    if (isSlick) {
      $slides = $track.find('.slick-slide:not(.slick-cloned)');
      var $list = $track.find('.slick-list');
      available = $list.length ? $list[0].clientWidth : trackEl.clientWidth;
      gap = 0;
      if ($slides.length) {
        var slideStyle = window.getComputedStyle($slides[0]);
        gap = (parseFloat(slideStyle.marginLeft) || 0) + (parseFloat(slideStyle.marginRight) || 0);
      }
    } else {
      var hadNoSliderClass = $root.hasClass('elvtd-cvslider--no-slider');
      if (!hadNoSliderClass) $root.addClass('elvtd-cvslider--no-slider');
      $slides = $track.children();
      available = trackEl.clientWidth;
      var trackStyle = window.getComputedStyle(trackEl);
      gap = parseFloat(trackStyle.columnGap) || parseFloat(trackStyle.gap) || 0;
      if (!hadNoSliderClass) $root.removeClass('elvtd-cvslider--no-slider');
    }

    var total = 0;
    $slides.each(function () {
      total += this.getBoundingClientRect().width;
    });
    var count = $slides.length;
    if (count > 1) total += gap * (count - 1);

    var avgWidth = count ? total / count : 0;
    var fitCount = avgWidth > 0 ? (available + gap) / (avgWidth + gap) : count;

    return {
      needsSlider: total > available + 1,
      slidesToShow: Math.max(1, Math.min(count > 0 ? count - 0.1 : 1, fitCount))
    };
  }

  function initSlider(root) {
    if (!window.jQuery || !window.jQuery.fn || !window.jQuery.fn.slick) return;

    var $root = window.jQuery(root);
    var $track = $root.find('[data-card-track]');
    if (!$track.length) return;

    var desktop = parseFloat(root.getAttribute('data-desktop')) || 4;
    var tablet = parseFloat(root.getAttribute('data-tablet')) || 2.5;
    var mobile = parseFloat(root.getAttribute('data-mobile')) || 1.2;
    var smallDesktopBp = parseFloat(root.getAttribute('data-small-desktop-bp')) || 0;
    var smallDesktop = parseFloat(root.getAttribute('data-small-desktop')) || desktop;
    var tabletBp = parseFloat(root.getAttribute('data-tablet-bp')) || 1024;

    var disableDesktop = root.getAttribute('data-disable-slider-desktop') === 'true';
    var disableTablet = root.getAttribute('data-disable-slider-tablet') === 'true';
    var disableMobile = root.getAttribute('data-disable-slider-mobile') === 'true';
    var disableMap = { desktop: disableDesktop, tablet: disableTablet, mobile: disableMobile };
    var forceArrowsBottom = root.getAttribute('data-force-arrows-bottom') === 'true';
    var infinite = root.getAttribute('data-infinite') === 'true';

    var noSliderClass = 'elvtd-cvslider--no-slider';
    var arrowSvg = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18.541 10.8928L13.824 6.17578L13.117 6.88278L17.733 11.4998H5V12.4998H17.735L13.117 17.1168L13.824 17.8238L18.541 13.1078C18.837 12.8118 19 12.4178 19 11.9998C19 11.5818 18.837 11.1878 18.541 10.8938V10.8928Z" fill="currentColor"/></svg>';

    var w = window.innerWidth;
    var bpKey = getBreakpointKey(w, tabletBp);
    var isMobile = bpKey === 'mobile';

    var $arrows = (isMobile || forceArrowsBottom)
      ? $root.find('.elvtd-cvslider__arrows--bottom')
      : $root.find('.elvtd-cvslider__arrows').not('.elvtd-cvslider__arrows--bottom');

    function hideArrows() {
      $arrows.css('visibility', 'hidden');
    }

    function checkArrows() {
      var visible = measureTrack($root, $track).needsSlider;
      $arrows.css('visibility', visible ? '' : 'hidden');
    }

    if (disableMap[bpKey]) {
      if ($track.hasClass('slick-initialized')) $track.slick('unslick');
      $root.addClass(noSliderClass);
      hideArrows();
      $root.data('cvState', 'disabled');
      return;
    }

    var trackInfo = measureTrack($root, $track);
    var needsSlider = trackInfo.needsSlider;
    var desiredState = bpKey + '-' + (needsSlider ? 'slider' : 'static');
    if ($root.data('cvState') === desiredState) {
      if (needsSlider) checkArrows();
      return;
    }
    $root.data('cvState', desiredState);

    if ($track.hasClass('slick-initialized')) {
      $track.slick('unslick');
    }

    if (!needsSlider) {
      $root.addClass(noSliderClass);
      hideArrows();
      return;
    }

    $root.removeClass(noSliderClass);

    var $allSlides = $track.children();
    var featureCount = $allSlides.filter('.elvtd-feature-card').length;
    var regularCount = $allSlides.length - featureCount;
    var totalCount = $allSlides.length;

    function adjustedSlidesToShow(bp) {
      if (featureCount === 0 || totalCount === 0) return bp;
      return totalCount / (featureCount + regularCount / bp);
    }

    var slickDesktop = adjustedSlidesToShow(desktop);
    var slickTablet = adjustedSlidesToShow(tablet);
    var slickMobile = adjustedSlidesToShow(mobile);
    var slickSmallDesktop = adjustedSlidesToShow(smallDesktop);

    if (bpKey === 'desktop') slickDesktop = trackInfo.slidesToShow;
    else if (bpKey === 'tablet') slickTablet = trackInfo.slidesToShow;
    else slickMobile = trackInfo.slidesToShow;

    if (infinite) {
      var loopSlides = function (n) {
        return Math.max(1, Math.min(Math.ceil(n), totalCount - 1));
      };
      slickDesktop = loopSlides(slickDesktop);
      slickTablet = loopSlides(slickTablet);
      slickMobile = loopSlides(slickMobile);
      slickSmallDesktop = loopSlides(slickSmallDesktop);
    }

    $track.off('breakpoint.cvslider').on('breakpoint.cvslider', checkArrows);

    var responsiveBreakpoints = [
      { breakpoint: 1024, settings: { slidesToShow: slickTablet, variableWidth: true } },
      { breakpoint: 767, settings: { slidesToShow: slickMobile, variableWidth: true } }
    ];
    if (smallDesktopBp > 1024) {
      responsiveBreakpoints.unshift({
        breakpoint: smallDesktopBp,
        settings: { slidesToShow: slickSmallDesktop, variableWidth: true }
      });
    }

    $track.slick({
      slidesToShow: slickDesktop,
      slidesToScroll: 1,
      variableWidth: true,
      arrows: true,
      dots: false,
      infinite: infinite,
      draggable: true,
      swipe: true,
      touchMove: true,
      appendArrows: $arrows,
      prevArrow: '<button type="button" class="slick-arrow slick-prev" aria-label="Previous">' + arrowSvg + '</button>',
      nextArrow: '<button type="button" class="slick-arrow slick-next" aria-label="Next">' + arrowSvg + '</button>',
      responsive: responsiveBreakpoints
    });

    setTimeout(checkArrows, 50);
  }

  function initVideoSlides(root) {
    var slides = root.querySelectorAll('.elvtd-video-slide[data-video-slide="true"]');

    Array.prototype.forEach.call(slides, function (slide) {
      if (slide.getAttribute('data-vs-bound') === 'true') return;
      var video = slide.querySelector('.elvtd-video-slide__video');
      var ctrl = slide.querySelector('.elvtd-video-slide__ctrl');
      if (!video || !ctrl) return;

      var play = function () {
        Array.prototype.forEach.call(document.querySelectorAll('.elvtd-video-slide.is-playing'), function (other) {
          if (other !== slide && typeof other.elvtdPauseVideo === 'function') other.elvtdPauseVideo();
        });
        video.muted = false;
        var promise = video.play();
        if (promise && typeof promise.catch === 'function') {
          promise.catch(function () {});
        }
        slide.classList.add('is-playing');
        ctrl.setAttribute('aria-pressed', 'true');
      };

      var pause = function () {
        video.pause();
        slide.classList.remove('is-playing');
        ctrl.setAttribute('aria-pressed', 'false');
      };

      slide.elvtdPauseVideo = pause;

      ctrl.addEventListener('click', function () {
        if (slide.classList.contains('is-playing')) {
          pause();
        } else {
          play();
        }
      });

      video.addEventListener('ended', function () {
        slide.classList.remove('is-playing');
        ctrl.setAttribute('aria-pressed', 'false');
      });

      slide.setAttribute('data-vs-bound', 'true');
    });
  }

  function initVideos(root) {
    var cards = root.querySelectorAll('.elvtd-media-card[data-has-video="true"]');

    Array.prototype.forEach.call(cards, function (card) {
      if (card.getAttribute('data-video-bound') === 'true') return;
      var video = card.querySelector('.elvtd-media-card__video');
      if (!video) return;

      var play = function () {
        var promise = video.play();
        if (promise && typeof promise.catch === 'function') {
          promise.catch(function () {});
        }
        card.classList.add('is-playing');
      };

      var stop = function () {
        video.pause();
        try { video.currentTime = 0; } catch (e) {}
        card.classList.remove('is-playing');
      };

      card.addEventListener('mouseenter', play);
      card.addEventListener('mouseleave', stop);
      card.addEventListener('touchstart', function () {
        if (card.classList.contains('is-playing')) {
          stop();
        } else {
          play();
        }
      }, { passive: true });

      card.setAttribute('data-video-bound', 'true');
    });
  }

  function initVideosAll() {
    var roots = document.querySelectorAll('[data-card-slider]');
    Array.prototype.forEach.call(roots, function (root) {
      initVideos(root);
      initVideoSlides(root);
    });
  }

  function initSlidersAll() {
    var roots = document.querySelectorAll('[data-card-slider]');
    Array.prototype.forEach.call(roots, function (root) {
      initSlider(root);
    });
  }

  function whenSlickReady(cb) {
    var tries = 0;
    (function check() {
      if (window.jQuery && window.jQuery.fn && window.jQuery.fn.slick) {
        cb();
      } else if (tries < 200) {
        tries += 1;
        setTimeout(check, 50);
      }
    })();
  }

  function boot() {
    initVideosAll();
    whenSlickReady(initSlidersAll);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }


  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      whenSlickReady(initSlidersAll);
    }, 200);
  });

  document.addEventListener('shopify:section:load', function (event) {
    var root = event && event.target
      ? event.target.querySelector('[data-card-slider]')
      : null;
    if (root) {
      initVideos(root);
      initVideoSlides(root);
      whenSlickReady(function () { initSlider(root); });
    } else {
      boot();
    }
  });
})();
